import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, ToggleButton, ToggleButtonGroup } from '@mui/material';

export interface FormToggleButtonOption {
  label: string;
  value: string;
  condition?: boolean;
}

interface FormToggleButtonProps {
  name: string;
  options: FormToggleButtonOption[];
  handleToggleChange?: (value: string) => void;
}

const defaultProps = {
  handleToggleChange: undefined,
};

export const FormToggleButton: FC<FormToggleButtonProps> = ({ handleToggleChange, name, options }) => {
  const { control } = useFormContext();
  return (
    <FormControl component="fieldset">
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <ToggleButtonGroup
              value={typeof value.toFormat === 'function' ? value?.toFormat && value?.toFormat('dd-MM-yyyy') : value}
              onChange={(e, val) => {
                onChange(e);
                if (handleToggleChange) {
                  handleToggleChange(val);
                }
              }}
              exclusive
              className="input__toggle-button-group toggle-button-group"
            >
              {options.map((el) => {
                return (
                  <ToggleButton key={el.label} value={el.value} className="toggle-button">
                    {el.label}
                  </ToggleButton>
                );
              })}
            </ToggleButtonGroup>
          );
        }}
      />
    </FormControl>
  );
};
FormToggleButton.defaultProps = defaultProps;
